<template>
  <transition name="el-fade-in-linear">
    <div class="back-top" v-if="isScroll" @click="scrollTop()">
      <!-- <el-backtop target=".page-component__scroll .el-scrollbar__wrap"></el-backtop> -->
      <i class="el-icon-upload2"></i><span>回到顶部</span>
    </div>
  </transition>
</template>

<script>

export default {
  name: '',

  data () {
    return {
      isScroll: false
    }
  },
  methods: {
    // 下拉加载更多数据添加方法
    handleScroll: function () {
      // let clientHeight = document.documentElement.clientHeight || document.body.clientHeight // 窗口的高度
      var scrollTop = document.documentElement.scrollTop// 顶部距离窗口的高度
      // var result = document.body.scrollHeight// body的高度
      // var scrollFooter = 200// 网页底部的高
      if (scrollTop > 0) {
        this.isScroll = true
      } else {
        this.isScroll = false
      }
    },
    scrollTop () {
      document.documentElement.scrollTop = 0
    }
  },
  mounted () {
    // 下拉加载更多监听滚轮
    window.addEventListener('scroll', this.handleScroll) // 监听（绑定）滚轮 滚动事件
  },
  created () {
    // this.aboutInfo = JSON.parse(localStorage.getItem('aboutInfo'))
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .back-top{
    position: fixed;
    right: 20px;
    bottom:50px;
    background:#cc0000;
    text-align: center;
    padding:10px;
    border-radius: 10px;
    cursor: pointer;

  }
  .back-top i{
    font-size: 20px;
    color: #fff;
  }
  .back-top span{
    display: block;
    color:#fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/BackTop/BackTop.vue